import { encode as base64_encode } from "base-64";
import SHA256 from "crypto-js/sha256";
import tagManagerEvents from "../utils/GoogleTagManager";
import img1 from "../Assets/imgs/mahi_sheikh_4x.webp";
import img2 from "../Assets/imgs/mathira_4x.webp";
import img3 from "../Assets/imgs/fazeela__4x.webp";
import img4 from "../Assets/imgs/atufa_tul_jannat_4x.webp";
import img5 from "../Assets/imgs/darakshah_4x.webp";
import img6 from "../Assets/imgs/abiha_fatima_4x.webp";
import { AxiosError } from "axios";
import AppMessage from "../Constant/AppMessage";

export const navigateToHome = (
  msisdn: string,
  subPackage: any,
  sessionId: string
) => {
  const encodedMsisdn = base64_encode(msisdn);
  const packageType =
    subPackage.toLowerCase() === "pre" ? "prepaid" : "postpaid";
  const encodedPackage = base64_encode(packageType);
  const _sessionId = base64_encode(sessionId);
  let url =
    `${window.location.origin}/home?user=${encodedMsisdn}&package=${encodedPackage}&utmInfo=${_sessionId}`.replace(
      "http:",
      "https:"
    );
  window.location.replace(url);
};

export const triggerSubscriptionEvent = (adNetwork: string, utmsource: any) => {
  const tagName =
    adNetwork.toLowerCase() === "tiktok" ||
    adNetwork.toLowerCase() === "tik tok"
      ? "econTikTok"
      : adNetwork.toLowerCase() === "google"
      ? "econceptions"
      : utmsource;
  tagManagerEvents("SUBSCRIBE", tagName);
};

export const redirct = () => {
  let url = window.location.origin;
  url = `${url}/home`;
  if (url.includes("http:")) {
    url = url.replace("http", "https");
  }
  window.location.replace(url);
};

type CookieData = {
  msisdn: string;
  token: string;
};

export const onpressLogoutBtn = () => {
  clearAllCookies();
  window.location.replace(window.location.origin + "/landing");
};

export const setCookie = (msisdn: string, token: string): void => {
  clearAllCookies();
  const data: CookieData = { msisdn, token };

  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data)
  )}; SameSite=Strict; path=/`;
};

export const getCookie = (name: string): CookieData | null => {
  try {
    const cookies: Record<string, string> = document.cookie
      .split(";")
      .reduce((acc: Record<string, string>, cookie: string) => {
        const [key, value] = cookie.split("=");
        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});

    return cookies[name] ? (JSON.parse(cookies[name]) as CookieData) : null;
  } catch (e) {
    console.error("Error parsing cookie:", e);
    return null;
  }
};

export const clearAllCookies = (): void => {
  document.cookie.split(";").forEach((cookie: string) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = () => {
  clearAllCookies();
  window.location.replace(window.location.origin + "/landing");
};
export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};

export let suggestedAccountList = {
  status: 0,
  result: [
    {
      id: 73,
      username: "Mahi sheikh",
      name: "Mahi sheikh",
      nick: "Mahi sheikh",
      picture: img1,
      isFollowed: false,
    },
    {
      id: 1673387,
      username: "Real_Mathira",
      name: "Mathira",
      nick: "Real_Mathira",
      picture: img2,
      isFollowed: false,
    },
    {
      id: 5269631,
      username: "rosemohammed777",
      name: "Rose Muhammad",
      nick: "Rose Muhammad",
      picture: img3,
      isFollowed: false,
    },
    {
      id: 4186542,
      username: "official_a_t_j",
      name: "Atufa Tul Jannat",
      nick: "Atufa Tul Jannat",
      picture: img4,
      isFollowed: false,
    },
    {
      id: 4186985,
      username: "darakhshankhan_",
      name: "Darakhshan khan",
      nick: "Darakhshan khan",
      picture: img5,
      isFollowed: false,
    },
    {
      id: 60,
      username: "abihanaqvi_officiall",
      name: "Abiha Naqvi",
      nick: "Abiha Naqvi",
      picture: img6,
      isFollowed: false,
    },
  ],
};


export const formatTime = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  if (minutes === 0 && seconds !== 0) {
    return `${seconds} sec`;
  }
  return `${minutes} min`;
};


export const getInitials = (name: string): string => {
  if (!name) return "NA";
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};


export const getErrorDataCase = (e: unknown): string => {
  try {
    if (e instanceof AxiosError && e?.response?.data?.result) {
      return e?.response?.data?.result;
    }
    return AppMessage.requestFailed;
  } catch (e) {
    return AppMessage.requestFailed;
  }
};


export enum VolumeCategory {
  IGNORE = "ignore",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export const getVolumeCategory = (level: number): VolumeCategory => {

  if (level < 10) return VolumeCategory.IGNORE;
  if (level < 50) return VolumeCategory.LOW;
  if (level < 80) return VolumeCategory.MEDIUM;
  return VolumeCategory.HIGH;
};


